export const WARNING_PANEL_LABELS = {
  actionRequired: 'Action Required!',
  attention: 'Attention!',
  success: 'Success!',
};
